export default __webpack_public_path__ + "images/12_thumbnail.jpg";